<footer class="user-section px-3 py-3 d-flex align-items-center border-top border-top">

  <!-- Avatar Circle -->
  <div class="user-avatar rounded-circle me-2 d-flex justify-content-center align-items-center text-dark fw-light avatar-size">
    {{ initials }}
  </div>

  <!-- Full Name -->
  <div class="flex-grow-1">
    <p class="text-white text-xs mb-0 sidebar-user-name">{{ full_name }}</p>
  </div>

</footer>
